import { useI18n } from "@/lib/i18n";

export default function Stats() {
  const { t } = useI18n();

  return (
    <section className="py-16 lg:py-20 border-t border-border">
      <div className="mx-auto max-w-container px-6 lg:px-10">
        <div className="grid sm:grid-cols-3 gap-12 lg:gap-8">
          {t.home.stats.map(([value, label], i) => (
            <div key={label} className="reveal text-center" style={{ transitionDelay: `${i * 90}ms` }}>
              <div className="font-serif text-6xl lg:text-7xl text-primary leading-none">{value}</div>
              <p className="mt-3 text-[15px] text-muted-foreground leading-relaxed max-w-[260px] mx-auto">
                {label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
